<template>
  <v-col cols="auto">
    <v-dialog v-model="dialog" transition="dialog-bottom-transition" max-width="1300" persistent>
      <template v-slot:activator="{ on, attrs }">
        <v-fab-transition> 
          <v-btn
            v-bind="attrs"
            v-on="on"
            color="primary"
            class="text-capitalize button-shadow mb-3 mb-sm-0"
          >Nova Prestação de Contas</v-btn>
        </v-fab-transition>
      </template>
      <template>
        <v-form @submit.prevent="save" enctype="multipart/form-data" ref="form" v-model="valid" lazy-validation>
          <v-card>
            <v-toolbar color="primary" class="title" tile elevation="0" dark>Nova Prestação de Contas</v-toolbar>
            <v-card-text>
              <v-row>
                <v-col cols="12" class="mb-n4">
                  <span class="font-weight-bold text-uppercase">Projeto:</span>
                  <p class="font-weight-light title ">
                    {{ projeto.titulo }}
                  </p>
                </v-col>

                <v-col cols="4" class="mb-n4">
                  <span class="font-weight-bold text-uppercase">Parceiro:</span>
                  <p class="font-weight-light title">
                    {{ usuario.organizacao ? usuario.organizacao.nome : '' }}
                  </p>
                </v-col>
                <v-col cols="4" class="mb-n4">
                  <span class="font-weight-bold text-uppercase">Responsável:</span>
                  <p class="font-weight-light title ">
                    {{ usuario.nome }}
                  </p>
                </v-col>
                <v-col cols="4" class="mb-n4">
                  <span class="font-weight-bold text-uppercase">E-mail:</span>
                  <p class="font-weight-light title ">
                    {{ usuario.email }}
                  </p>
                </v-col>
                
                <v-col cols="3" class="mb-n4">
                  <v-select
                    v-model="formulario.periodo"
                    class="text-center"
                    :items="meses"
                    item-text="descricao"
                    label="Período"
                    :rules="[(v) => !!v || 'Período da Prestação de Conta é obrigatório.']"
                    filled
                    multiple
                  ></v-select>
                </v-col>

                <v-col offset="1" cols="4" class="mb-n4">
                  <span class="font-weight-bold text-uppercase">Data:</span>
                  <p class="font-weight-light title ">
                    {{ this.dataMoment }}
                  </p>
                </v-col>                

                <v-col cols="12" class="mt-n8">
                  <v-checkbox
                    v-model="formulario.relatorioDespesa"
                    label="Relátorio de Despesas"
                    hide-details
                  ></v-checkbox>
                  <v-checkbox
                    v-model="formulario.extratoContaCorrenteInvestimento"
                    label="Extrato de Conta Corrente e Investimentos"
                    hide-details
                  ></v-checkbox>
                  <v-checkbox
                    v-model="formulario.documentoComprovanteDespesa"
                    label="Documentos Comprovantes de Despesas"
                    hide-details
                  ></v-checkbox>
                  <v-checkbox
                    v-model="formulario.folhaDedicacaoPessoal"
                    label="Folha de Dedicação de Pessoal"
                    hide-details
                  ></v-checkbox>
                  <v-checkbox
                    v-model="formulario.frequenciaPessoalProjeto"
                    label="Frequência Pessoal Projeto"
                    hide-details
                  ></v-checkbox>
                  <v-checkbox
                    v-model="formulario.inventario"
                    label="Inventário"
                    hide-details
                  ></v-checkbox>
                  <v-checkbox
                    v-model="formulario.contabilidade"
                    label="Contabilidade"
                    hide-details
                  ></v-checkbox>
                  <v-checkbox
                    v-model="formulario.outros"
                    label="Outros"
                    hide-details
                  ></v-checkbox>
                  <v-textarea
                    v-model="formulario.outrosItens"
                    :disabled="!formulario.outros"
                    label="Informe outros itens"
                    filled
                    rows="1"
                    auto-grow
                  ></v-textarea>
                </v-col>
                <v-col cols="12" class="mb-n3 mt-n6">
                  <v-textarea
                    v-model="formulario.links"
                      label="Link"
                      filled
                      rows="1"
                      auto-grow
                  ></v-textarea>
                </v-col>
                <v-col cols="12" class="mb-n3 mt-n4">
                  <v-textarea
                    v-model="formulario.observacoes"
                      label="Observações"
                      filled
                      rows="3"
                      auto-grow
                  ></v-textarea>
                </v-col>
                <v-col cols="12" class="mb-n3 mt-n4">
                  <v-file-input
                    small-chips
                    multiple
                    label="Arquivo"
                    v-model="file"
                  ></v-file-input>
                </v-col>
                <v-col cols="12" class="mb-n3 mt-n4">
                  <v-list subheader v-if="file">
                    <v-list-item link>
                        <v-list-item-content class="py-2">
                          <v-list-item-title>{{file ? file[0].name : ''}}</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-col>
              </v-row>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions class="justify-end py-3 mx-1">

              <v-btn color="secondary" @click.prevent="fecharELimpar">Cancelar</v-btn>
              <v-btn color="primary" type="submit"> Salvar </v-btn>
            </v-card-actions>
          </v-card>
        </v-form>
      </template>
    </v-dialog>
  </v-col>
</template>

<script>

import {mapActions} from "vuex";
import moment from 'moment'
moment.locale('pt')


export default {
  components: {},
  props: {
  },
  watch: {
//    'formulario.data' () {
//      this.dataFormatada = this.formatarData(this.formulario.data)
//    },
  },  
  computed: {
    usuario() {
      return this.$store.getters["usuario/getUser"]
    },    
    projeto() {
      return this.$store.getters["projeto/getProjetoById"](
        parseInt(this.$route.params.projetoId)
      );
    },    
    meses() {
      let meses = this.$store.getters["projeto/getMeses"](parseInt(this.$route.params.projetoId));
      let mesesFormatado = []

      meses.forEach((mes, indice) => {
        let data = moment(mes);
        let mesFormatado = {
          numeroMes: indice + 1,
          descricao: data.format("MM/YYYY").toUpperCase(),
        }

        mesesFormatado.push(mesFormatado);
      });

      return mesesFormatado;
    }    
  },
  data() {
    return {
      valid: true,
      dialog: false,
      formulario: this.formulario ? Object.assign({}, this.formulario) : this.formularioReset(),
      dataFormatada: '',
      menu1: false,
      dataMoment: moment(new Date()).format("DD/MM/YYYY"),
      file: null
    };
  },
  methods: {
    ...mapActions('prestacaoConta', ['criarPrestacaoConta']),
    save() {
      if(this.$refs.form.validate()) {
        this.create().then((prestacaoConta) => {
          this.$refs.form.resetValidation()
          this.formulario = {};
          this.$emit("save", { prestacaoConta });
          this.dialog = false
          this.fecharELimpar()
        })
         .catch((error) => {
           if (error.response) {
             this.errorMessage = error.response.data
           }
         })
      }
    },
    create() {
      var payload = {
        projetoId: this.projeto.id, 
        prestacaoConta: this.formulario,
        //'file': this.file[0] ? this.file[0] : null
        'file': Array.isArray(this.file) ? this.file[0] : null 
      }

      return this.criarPrestacaoConta(payload);
    },
    fecharELimpar() {
      //this.$refs.form.reset()

      this.dialog = false
    },
    formularioReset() {
      return {data: ''};
    },
    formatarData (data) {
      if (!data) return null

      const [ano, mes, dia] = data.split('-')
      return `${dia}/${mes}/${ano}`
    },
    coverterData (data) {
      if (!data) return null

      const [dia, mes, ano] = data.split('/')
      return `${ano}-${mes.padStart(2, '0')}-${dia.padStart(2, '0')}`
    },  
  }, 
  created() {
    //this.dataFormatada = this.formatarData(this.formularioEditor.data)
    this.dataFormatada = this.dataMoment 

  },

};
</script>
